import { useQuery } from '@tanstack/react-query';
import { contentQueries } from 'services/content/contentQueries';
import type { ContentType } from 'utils/getContentType';

export const useContentMetadata = (contentType: ContentType, contentId: string) => {
  return useQuery(contentQueries.contentMetadataById(contentType, contentId));
};
